import { render, staticRenderFns } from "./Step1Basic.vue?vue&type=template&id=b6a2a91c&"
import script from "./Step1Basic.vue?vue&type=script&lang=js&"
export * from "./Step1Basic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports